export default __webpack_public_path__ + "static/media/loader.f31e0d36.svg";